import { render, staticRenderFns } from "./chartProject.vue?vue&type=template&id=048fda68"
import script from "./chartProject.vue?vue&type=script&lang=js"
export * from "./chartProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports